import { render } from "./CaseCard.vue?vue&type=template&id=656d3ed0"
import script from "./CaseCard.vue?vue&type=script&lang=js"
export * from "./CaseCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__